/*
 * Copyright (c) 2017 Ytica.com a.s. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 *
 */

import Vue from 'vue'
import Router from 'vue-router'
import Iframe from '@/components/Iframe'
import console from '../logger.js'

Vue.use(Router)

let iframeBaseUrl = window.location.protocol + '//' + window.location.host
// for testing purposes
// iframeBaseUrl = 'https://app.dev.ytica.com'
let iframeAppsBaseUrl = iframeBaseUrl.replace('//app.', '//apps.')

export default function initRouter (baseUrl) {
  return new Router({
    hashbang: false,
    // linkActiveClass: 'active',
    mode: 'history',
    base: baseUrl,
    routes: [
      {
        path: '/login',
        name: 'login',
        redirect: to => {
          let url = Vue.prototype.$identity.getRedirectToServiceSSOUrl('app', {'target_url': window.location.protocol + '//' + window.location.host})
          window.location.assign(url)
          // stop propagation
          throw new Error(url)
        }
      },
      {
        path: '/logout',
        name: 'logout',
        redirect: async to => {
          await Vue.prototype.$identity.logout()
          const url = Vue.config.SSO_URL + '/logout'
          window.location.assign(url)
          // send logout message to Flex
          window.parent.postMessage({
            app: 'mainApp',
            component: 'logout',
            type: 'onLogoutSuccess',
            value: true
          }, '*')
          // stop propagation
          throw new Error(url)
        }
      },
      {
        path: '/talkdesk',
        name: 'talkdesk',
        redirect: to => {
          const talkdeskInstallationId = to.query.talkdesk_installation_id
          const talkdeskUserId = to.query.talkdesk_user_id
          console.log(talkdeskInstallationId, talkdeskUserId)
          if (!talkdeskInstallationId || !talkdeskUserId) {
            return { name: 'login' }
          }

          // talkdesk user
          window.localStorage.setItem('talkdesk_user', true)

          let url = Vue.prototype.$identity.getRedirectToServiceSSOUrl('talkdesk', {
            'td_installation_id': talkdeskInstallationId,
            'td_user_id': talkdeskUserId,
            'target_url': window.location.protocol + '//' + window.location.host
          })
          window.location.assign(url)
          // stop propagation
          throw new Error(url)
        }
      },
      {
        path: '/',
        name: 'home'
      },
      {
        // b981eec4-23d1-4a5c-a93f-a8edb0f3d15e
        path: '/:account_id(\\w{8}-\\w{4}-\\w{4}-\\w{4}-\\w{12})',
        // name: 'account',
        component: Iframe,
        props: (route) => {
          switch (route.name) {
            case 'agents':
              return {url: iframeBaseUrl + '/realtime/', permissions: 'coaching:view', send_account_id: true}
            case 'analyze':
              return { url: iframeBaseUrl + '/dashboards/analyze', permissions: 'dashboards:analyze', send_account_id: true }
            case 'speechSearches':
              return { url: iframeBaseUrl + '/phrases/', permissions: 'phrases:view', send_account_id: true }
            case 'inspections':
              return {url: iframeBaseUrl + '/inspections/', permissions: 'inspections:view', send_account_id: true}
            case 'topics':
              return { url: iframeBaseUrl + '/ibis/', permissions: 'text.topics:view' }
            case 'assessments':
              return { url: iframeAppsBaseUrl + '/assessments/', permissions: 'assessment:manage', send_account_id: true }
            case 'dashboards':
              return {url: iframeBaseUrl + '/dashboards/', permissions: 'dashboards:view', send_account_id: true}
            default:
              return {url: iframeBaseUrl + '/dashboards/', permissions: 'dashboards:view', send_account_id: true}
          }
        },
        children: [
          {
            path: 'agents/:childPath(.*)?',
            name: 'agents'
          },
          {
            path: 'analyze/:childPath(.*)?',
            name: 'analyze'
          },
          {
            path: 'speech-searches/:childPath(.*)?',
            name: 'speechSearches'
          },
          {
            path: 'inspections/:childPath(.*)?',
            name: 'inspections'
          },
          {
            path: 'topics/:childPath(.*)?',
            name: 'topics'
          },
          {
            path: 'assessments/:childPath(.*)?',
            name: 'assessments'
          },
          {
            path: 'dashboards/:childPath(.*)?',
            name: 'dashboards'
          },
          {
            path: '',
            name: 'dashboardsRedirect',
            redirect: 'dashboards'
          }
        ]
      }
    ]
  })
}



// WEBPACK FOOTER //
// ./src/router/index.js